import {Navigate, NonIndexRouteObject} from "react-router"
import {UmsApp} from "../components/app/UmsApp";
import {ErrorPage} from "../components/page";
import {
    navigationStore,
    umsPrinterStore,
    userConfigurationStore,
    userDetailStore,
    userListStore,
    validationStore
} from "../store";
import React from "react";


const ums: NonIndexRouteObject[] = [
    {
        path: `/ums/user`,
        element: <UmsApp mode={'overview'}/>,
        errorElement: <ErrorPage/>,
        loader: async ({request}) => {
            userListStore.checkCreateUserAvailable()
            const searchParams = new URL(request.url).searchParams
            userListStore.page = parseInt(searchParams.get("page") || "") || 1
            userListStore.size = parseInt(searchParams.get("size") || "") || 25

            userListStore.load().finally()
            navigationStore.setActivePath(request)
            return null
        }
    },
    {
        path: `/ums/user/create`,
        element: <UmsApp mode={'create'}/>,
        errorElement: <ErrorPage/>,
        loader: async ({request}) => {
            validationStore.reset()

            navigationStore.setActivePath(request)
            return null
        }
    },
    {
        path: `/ums/user/me/configuration`,
        element: <UmsApp mode={'config'} />,
        errorElement: <Navigate to={`/dashboard`} replace={true}/>,
        loader: async ({params, request}) => {
            await Promise.all([
                umsPrinterStore.load(),
                userConfigurationStore.load()
            ])
            navigationStore.setActivePath(request)
            return null
        }
    },
    {
        path: `/ums/user/:id`,
        element: <UmsApp mode={'detail'}/>,
        errorElement: <ErrorPage/>,
        loader: async ({params, request}) => {
            validationStore.reset()
            userDetailStore.id = params.id
            const result = await userDetailStore.load()
            if (!result) {
                throw Error
            }
            navigationStore.setActivePath(request)
            return null
        }
    },
]

export {
    ums
}
